var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "c-modal",
    {
      attrs: { active: _vm.displayModal, title: _vm.title },
      on: { close: _vm.close },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function () {
            return [
              _c("c-button", {
                staticClass:
                  "reference-reasons-for-bonuses-create-modal__actions__reset",
                attrs: { size: "large", label: "Отменить" },
                on: { click: _vm.close },
              }),
              _c("c-button", {
                staticClass:
                  "reference-reasons-for-bonuses-create-modal__actions__save",
                attrs: { label: "Сохранить", color: "primary", size: "large" },
                on: { click: _vm.submit },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submit.apply(null, arguments)
            },
          },
        },
        [
          _c("c-input", {
            class: { "is-invalid": _vm.isSubmitted && _vm.nameError },
            attrs: {
              "floating-label": "Название категории",
              "max-length": 255,
              required: _vm.isSubmitted && _vm.nameError,
              "required-condition": _vm.isSubmitted && _vm.nameError,
            },
            model: {
              value: _vm.name,
              callback: function ($$v) {
                _vm.name = $$v
              },
              expression: "name",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }